// Use to give editable info (name, descriptions, etc.)

import React from 'react'
import { Col, Card, CardBody, CardHeader, FormGroup, Label, Input, } from 'reactstrap'
import getTrueProps from '../../../helpers/getTrueProps' 
const forOwn = require('mout/object/forOwn')

export default function NodeInfo (props) {
  let options = <option></option>
  const nullOption = <option key='nullNodeSourceOptions'></option>
  if (props.nodeSourceOptions) {
    const optionsArray = getTrueProps(props.nodeSourceOptions)
    options = optionsArray.map((option, n) => {
      return <option key={'nodeSourceOption' + n} value={option}>{option}</option>
    })
    options.splice(0, 0, nullOption)
  }
  
  return (
    <Col xs={props.xs} lg={props.lg}>
      <Card>
        <CardHeader>
          Node Info
        </CardHeader>
        <CardBody>
          <FormGroup>
            <Label htmlFor='nodeId'>Id</Label>
            <Input disabled type='text' id='nodeId' value={props.activeNode ? props.activeNode.id : ''} />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='activeNodeName'>Name</Label>
            <Input 
              type='text' 
              id='activeNodeName' 
              name='activeNodeName' 
              value={props.activeNodeName} 
              onChange={(e) => props.handleChange(e)} 
              disabled={props.activeNode ? false : true}
              getRef={props.nameRef}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='nodeCode'>Code</Label>
            <Input 
              type='text'
              id='nodeCode'
              name='nodeCode'
              value={props.nodeCode}
              onChange={(e) => props.handleChange(e)}
              disabled={props.activeNode ? false : true}
            />
          </FormGroup>
          <FormGroup>
            <Label>Source</Label>
            <Input
              type='select'
              id='nodeSource'
              name='nodeSource'
              value={props.nodeSource}
              onChange={(e) => props.handleChange(e)}
              disabled={props.activeNode ? false : true}
            >
              {options}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label htmlFor='nodeShortDescription'>Short Description</Label>
            <Input 
              type='text' 
              id='nodeShortDescription' 
              name='nodeShortDescription' 
              value={props.nodeShortDescription ? props.nodeShortDescription : ''}
              onChange={props.handleChange}
              disabled={props.activeNode ? false : true}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='nodeLongDescription'>Long Description</Label>
            <Input
              type='textarea'
              id='nodeLongDescription'
              name='nodeLongDescription'
              value={props.nodeLongDescription ? props.nodeLongDescription : ''}
              onChange={props.handleChange}
              disabled={props.activeNode ? false : true}
            />
          </FormGroup>
        </CardBody>
      </Card>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/KnowledgeMap/NodeInfo.js